// obsluha posuvníku pro nastavení ceny filtru
// (aktualizuje HTML prvky po každém obnovení snippetu)
FNC.filters.sliderize = src => {
    let fst = src.parentNode.children[1];
    let snd = src.parentNode.children[2];
    let fstI = src.parentNode.querySelector("span:first-of-type input[name='price[min]']");
    let sndI = src.parentNode.querySelector("span:last-of-type input[name='price[max]']");
    let intl = JSON.parse(fstI.dataset.sliderIntl);

    // úvodní synchronizace textových polí a posuvníků
    if(!fstI.value) fstI.value = fst.getAttribute("value");
    if(!sndI.value) sndI.value = snd.getAttribute("value");
    fst.setAttribute("value", fstI.value);
    snd.setAttribute("value", sndI.value);
    ID['price-min-value'].value = FN.priceFormat(fstI.value, intl);
    ID['price-max-value'].value = FN.priceFormat(sndI.value, intl);

    document.querySelectorAll('input#price-min-value').forEach(input => {
        input.value = FN.priceFormat(fstI.value, intl);
    });

    document.querySelectorAll('input#price-max-value').forEach(input => {
        input.value = FN.priceFormat(sndI.value, intl);
    });
 
    //fstI.value = null;
    //sndI.value = null;

    // posledně přesouvané kolečko vykresli nad tím druhým
    fst.addEventListener("focus", _=> fst.classList.add("top") || snd.classList.remove("top"));
    snd.addEventListener("focus", _=> snd.classList.add("top") || fst.classList.remove("top"));

    // nedovol přesunutí levého kolečka za pravé a pravého před levé
    fst.addEventListener("input", _=> +fst.value>=+snd.value && (fst.value = snd.value));
    snd.addEventListener("input", _=> +snd.value<=+fst.value && (snd.value = fst.value));

    // změň barvu posuvníku mezi kolečky
    let track = src.parentNode.children[0];
    let progressPct = elem => (elem.value-elem.min) / (elem.max-elem.min) * 100;
    let setFill = (pct1, pct2) => (track.style.backgroundImage =
        `linear-gradient(to right, var(--col-warn) 0 ${pct1}%, var(--col-fg) ${pct1}% ${pct2}%, var(--col-em) ${pct2}% 100%)`);
    let filler = _=> setFill(progressPct(fst), progressPct(snd));
    fst.addEventListener("input", filler);
    snd.addEventListener("input", filler);
    filler();

    // aktualizuj ceny pod posuvníkem (zahoď desetiny)
    fst.addEventListener("input", _ => {

        fstI.value = fst.value;

        ID['price-min-value'].value = FN.priceFormat(fst.value, intl);

        document.querySelectorAll('input#price-min-value').forEach(input => {
            input.value = FN.priceFormat(fst.value, intl);
        });

    });

    snd.addEventListener("input", _ => {
        sndI.value = snd.value;

        ID['price-max-value'].value = FN.priceFormat(snd.value, intl);

        document.querySelectorAll('input#price-max-value').forEach(input => {
            input.value = FN.priceFormat(snd.value, intl);
        });

    });

    // odešli formulář při změně limitu ceny
    let sendForm = async e => {
        let el = e.target;
        if(el.dataset.value==e.value) return;
        el.dataset.value = el.value;
        //el.form.elements["price[min]"].value = fst.value;
        //el.form.elements["price[max]"].value = snd.value;
        await naja.uiHandler.submitForm(el.form);
        FNC.Menu.init();
    }
    fst.addEventListener("mouseup", sendForm); fst.addEventListener("touchend", sendForm);
    snd.addEventListener("mouseup", sendForm); snd.addEventListener("touchend", sendForm);
}

// nastav černé nebo bílé zaškrtnutí, dle světlosti pozadí
/*
window.setColCheck = _=> {
    let elems = document.getElementById("colors-list").getElementsByClassName("color");
    [...elems].forEach(elem => elem.style.setProperty("--col-fg", FN.getLuma(elem)>128 ? "black" : "white"));
}
*/

// rozbalení filtrů na desktopech
FNC.filters.openDetails = _=> {

    let breaker = parseInt(FN.getCSSVar(document.body, "--break-md-end"));

    document.querySelectorAll("details.filter").forEach(detail => {
        let inputs = detail.querySelectorAll("input");
        let more = detail.querySelector(".more");
        more && inputs.forEach((input,i) =>
            i>9 && input.checked &&
                (more.previousElementSibling.style.maxHeight = more.style.display = 'none')
        );
    });
}
if(document.querySelector("details.filter")) FNC.filters.openDetails();

// automatické otevření filtrů na mobilních displejích
FNC.filters.submitHandler = (e, param = false) => {
    if(e && e.detail.request.url.indexOf("remove")>0) return;
    let breaker = parseInt(FN.getCSSVar(document.body, "--break-md-end"));
    if(document.body.offsetWidth > breaker) return FNC.filters.openDetails();
    if (!_.isNull(ID.mobile1)) {
        ID.mobile1.checked = param;

    }

    //document.querySelectorAll("details.filter").forEach(detail => detail.open = false);

    document.querySelectorAll("details.filter").forEach(detailFor => {

        let detailTAct = ID["detail-"+sessionStorage.filter];

        if (detailTAct && detailFor) {
            if(detailTAct.id != detailFor.id){
                detailFor.open = false;
            }else{

            }
        }
    });
}

FNC.filters.submit = async (frm, param = true) => {

    await naja.uiHandler.submitForm(frm);

    FNC.Menu.init(); // filtry znefunkční horní menu
    // naja.addEventListener('success', FNC.filters.submitHandler);
    FNC.filters.submitHandler(null, param);

    const selectElementBrand = document.querySelector("#detail-x-page #frm-filters-filtersForm-selectFilter-brand");
    if (!_.isNull(selectElementBrand)) {
        if (selectElementBrand.selectedIndex > 0) {
            const elements = document.querySelectorAll('.cancel-filter-button');

            if (elements.length > 0) {
                //console.log(`Found ${elements.length} elements! SHOW`);
                elements.forEach((element) => {
                    element.style.display = 'flex';
                });
            }
        } else {
            const elements = document.querySelectorAll('.cancel-filter-button');
            if (elements.length > 0) {
                //console.log(`Found ${elements.length} elements! SHOW`);
                elements.forEach((element) => {
                    element.style.display = 'none';
                });
            }
        }
    }
}

FNC.filters.submitSmallFilter = async frm => {

    saveFiltrsValue();

    await naja.uiHandler.submitForm(frm);
    FNC.Menu.init(); // Filtry znefunkční horní menu
    FNC.filters.submitHandler(null); // Předejte explicitně `true`

    try {
        const selectElementBrand = document.querySelector(".smallFilterMobile #frm-filters-filtersForm-selectFilter-brand");
        const selectElementModel = document.querySelector(".smallFilterMobile #frm-filters-filtersForm-selectFilter-model");

        const selectElementModelDiv = document.getElementById("smallFilterMobileSelect-model");
        const selectElementYearDiv = document.getElementById("smallFilterMobileSelect-year");

        if (selectElementBrand.selectedIndex > 0) {
            //selectElementModelDiv.style.display = "block";

            const elements = document.querySelectorAll('.cancel-filter-button');
            if (elements.length > 0) {
                elements.forEach((element) => {
                    element.style.display = 'flex';
                });
            }
        } else {
            //selectElementModelDiv.style.display = "none";

            const elements = document.querySelectorAll('.cancel-filter-button');
            if (elements.length > 0) {
                elements.forEach((element) => {
                    element.style.display = 'none';
                });
            }
        }

        if (selectElementModel.selectedIndex > 0) {
            //selectElementYearDiv.style.display = "block";
        } else {
            //selectElementYearDiv.style.display = "none";
        }
    } catch (error) {
        console.log(error);
    }    
};

// číslo 1 u selectFilterForm, pokud je filtr aplikován
if(FNC.filters.frm=ID["frm-selectCategoryFilter-selectFilterForm"]) naja.addEventListener('success', _=> {

    let tgt = frm.querySelector("summary span");
    tgt.innerHTML = FNC.filters.frm.querySelector("select").value ? "1" : "";
});

FNC.filters.clearFilters = async frm => {
    window.localStorage.setItem("selValueBrand",0);
    window.localStorage.setItem("selValueModel",0);
    window.localStorage.setItem("selValueYear",0);
}

function saveFiltrsValue(){

    try {
        const selectElementBrand = document.querySelector("#filter-brand #frm-filters-filtersForm-selectFilter-brand");
        const selectElementModel = document.querySelector("#filter-model #frm-filters-filtersForm-selectFilter-model");
        const selectElementYear = document.querySelector("#filter-year #frm-filters-filtersForm-selectFilter-year");

        if (selectElementBrand.selectedIndex > 0) {

            //console.log(selectElementBrand.value);
            const elements = document.querySelectorAll('.cancel-filter-button');
            if (elements.length > 0) {
                //console.log(`Found ${elements.length} elements! SHOW`);
                elements.forEach((element) => {
                    element.style.display = 'flex';
                });
            }

            if (selectElementBrand.value > 0) {
                window.localStorage.setItem("selValueBrand",selectElementBrand.value);
            }else{
                window.localStorage.setItem("selValueBrand",0);
            }
        }else{

            const elements = document.querySelectorAll('.cancel-filter-button');
            if (elements.length > 0) {
                //console.log(`Found ${elements.length} elements! SHOW`);
                elements.forEach((element) => {
                    element.style.display = 'none';
                });
            }

            window.localStorage.setItem("selValueBrand",0);
        }

        if (selectElementModel.selectedIndex > 0) {
            if (selectElementModel.value > 0) {
                window.localStorage.setItem("selValueModel",selectElementModel.value);
            }else{
                window.localStorage.setItem("selValueModel",0);
            }
        }else{
            window.localStorage.setItem("selValueModel",0);
        }

        if (selectElementYear.selectedIndex > 0) {
            if (selectElementModel.value > 0) {
                window.localStorage.setItem("selValueYear",selectElementYear.value);
            }else{
                window.localStorage.setItem("selValueYear",0);
            }
        }else{
            window.localStorage.setItem("selValueYear",0);
        }

    } catch (error) {
        console.log(error); 
    }
}

FNC.filters.validateAndRedirect = function(baseUrl) {

    var selectBox = document.getElementById('frm-filters-filtersForm-selectFilter-brand');
    var infoDiv = document.querySelector('.filtersPageComponentHomepageButttonSearchInfo');

    if (!selectBox.value) {
        infoDiv.style.display = 'block';
        return;
    }

    infoDiv.style.display = 'none';

    window.location.href = baseUrl.replaceAll('"','');
};